var map = {
	"./bx-cog.svg": 32892,
	"./bx-desktop.svg": 50141,
	"./bx-package.svg": 3685,
	"./bx-receipt.svg": 87829,
	"./bx-user-circle.svg": 16527,
	"./driver.png": 99522,
	"./icon-mi-cuenta.png": 63103,
	"./order.svg": 50476,
	"./order_old.svg": 73782,
	"./payments.png": 14781,
	"./seller.png": 38989,
	"./truck.svg": 54157,
	"./wallet.svg": 55499
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67682;